import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    style: !_vm.twinCanBeEdited ? 'opacity: 0.9' : '',
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.unsavedTitle'),
      "open": _vm.unsavedPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptConfirm'),
        color: 'danger',
        emit: 'discard-changes'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.unsavedPrompt = false;
      },
      "discard-changes": function ($event) {
        return _vm.unsavePromptNextPersist();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.unsavedText')) + "\n  ")]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisableConfirmation'),
      "open": _vm.disableDialog,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable'),
        color: 'red',
        emit: 'disable',
        disabled: _vm.hasDependentDevices || _vm.loading,
        dataCy: 'btn_twin_disable_confirm'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.disableDialog = false;
      },
      "disable": _vm.dialogDisable
    }
  }, [_vm.hasDependentDevices ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinIsParentalObject')) + "\n      "), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.twinDependencies.virtualDevices,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [[_c('a', {
          attrs: {
            "href": `/#/virtual-devices/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))])], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 3286619881)
  })] : _vm._e()], 2), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.exportDialog,
      callback: function ($$v) {
        _vm.exportDialog = $$v;
      },
      expression: "exportDialog"
    }
  }, [_vm.exportDialog ? _c('core-dtwin-csv-exportd', {
    attrs: {
      "dtwinId": _vm.twinObject.id,
      "tenantId": _vm.twinObject.tenantId,
      "ressource": "digital-twin-state-values"
    },
    on: {
      "close-export-dialog": function ($event) {
        _vm.exportDialog = false;
      }
    }
  }) : _vm._e()], 1), _c(VForm, {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.prepareSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VRow, {
    staticClass: "pb-0 mx-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.showHeaderMap ? _c('core-dtwin-map-header-map', {
    style: `width: 100%; ${!_vm.twinCanBeEdited ? 'opacity: 0.5' : ''}`,
    attrs: {
      "geoCoordinates": _vm.dtwinCoordinates,
      "overlayInfo": _vm.dtwinOverlayInfo,
      "dtwTitle": _vm.twinObject.title,
      "dtwData": _vm.twinObject.data,
      "mapInteractive": false,
      "header": ""
    },
    on: {
      "polygonUpdated": _vm.dtwinGeopolygonUpdated,
      "markerUpdated": _vm.dtwinCoordinateUpdated
    },
    scopedSlots: _vm._u([_vm.twinTemplate ? {
      key: "twinTemplateLink",
      fn: function () {
        return [_c('div', {
          staticClass: "ml-n2 mt-12 dtwin-subtitle-frame header-frame text-truncate"
        }, [_c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fa-sitemap")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.linkedToTemplate')) + ":\n            "), _c('router-link', {
          attrs: {
            "to": `/twin-templates/${_vm.twinTemplate.id}?tab=tab-main`
          }
        }, [_vm._v("\n              " + _vm._s(_vm.twinTemplate.title) + "\n            ")])], 1)];
      },
      proxy: true
    } : null], null, true)
  }) : _vm._e(), !_vm.showHeaderMap && _vm.headerBG ? _c(VCol, {
    staticClass: "pa-0"
  }, [_c(VParallax, {
    style: `width: 100%; ${!_vm.twinCanBeEdited ? 'opacity: 0.5' : ''}`,
    attrs: {
      "height": "240",
      "src": _vm.headerBG
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 header-text dtwin-title-frame text-truncate"
  }, [_vm.twinObject.data.faIcon && _vm.twinObject.data.faIcon.trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.twinObject.data.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.twinObject.title) + "\n          ")], 1)])], 1) : _vm._e(), !_vm.showHeaderMap && !_vm.headerBG ? _c(VCol, {
    staticClass: "pa-0"
  }, [_c('div', {
    staticStyle: {
      "height": "143px"
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 header-text dtwin-title-frame text-truncate"
  }, [_vm.twinObject.data.faIcon && _vm.twinObject.data.faIcon.trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.twinObject.data.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.twinObject.title) + "\n          ")], 1), _vm.twinTemplate ? _c('div', {
    staticClass: "pl-3 pr-3 dtwin-subtitle-frame text-truncate"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fa-sitemap")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.linkedToTemplate')) + ":\n            "), _c('router-link', {
    attrs: {
      "to": `/twin-templates/${_vm.twinTemplate.id}?tab=tab-main`
    }
  }, [_vm._v("\n              " + _vm._s(_vm.twinTemplate.title) + "\n            ")])], 1) : _vm._e()])]) : _vm._e()], 1), _c('div', _vm._b({}, 'div', _vm.actionBoxClass, false), [_c('div', {
    class: `px-2 ${_vm.actionBoxGradientClass}`,
    staticStyle: {
      "height": "60px"
    }
  }, [_vm.twinObject.properties && _vm.twinObject.properties.disabled ? _c('div', {
    staticClass: "ml-1 mr-1 v-btn danger--text",
    staticStyle: {
      "float": "left",
      "margin": "10px auto",
      "line-height": "47px",
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisabled')) + "\n        ")]) : _vm._e(), _vm.twinObject && _vm.twinObject.id ? _c('core-dtwin-share-button-dialogue', {
    attrs: {
      "twinId": _vm.twinObject.id
    }
  }) : _vm._e(), _c('core-favoriteselect', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "objectId": _vm.twinObject.id,
      "type": "digitalTwin",
      "asRoundButton": ""
    }
  }), _vm.twinObject && _vm.twinObject.id ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMap'),
      "color": _vm.color,
      "prepend-icon": "fa-map-marked-alt"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          path: '/digitaltwin-mgmt/map/twin/' + _vm.twinObject.id,
          query: {
            edit: 'true'
          }
        });
      }
    }
  }) : _vm._e(), _vm.twinObject && _vm.twinObject.id ? _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      "min-width": "320px",
      "max-height": "500px",
      "offset-y": "",
      "nudge-bottom": "4",
      "bottom": "",
      "z-index": "1"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c('core-button', _vm._g({
          attrs: {
            "title": _vm.$i18n_t('Common.digitalTwins.selectTwin'),
            "color": _vm.color,
            "disabled": _vm.cloading,
            "prepend-icon": "fa-sitemap"
          }
        }, on))];
      }
    }], null, false, 1833204502),
    model: {
      value: _vm.twinSelectionTreeMenu,
      callback: function ($$v) {
        _vm.twinSelectionTreeMenu = $$v;
      },
      expression: "twinSelectionTreeMenu"
    }
  }, [_c(VCard, [_c('core-dtwin-tree-default', {
    attrs: {
      "userId": _vm.sessionUserId,
      "activeDtwinId": _vm.twinObject ? _vm.twinObject.id : undefined,
      "searchEnabled": false,
      "cached": "",
      "loadFullDtwinData": "",
      "canSelectDisabledTwins": ""
    },
    on: {
      "onSelectedChange": _vm.digitalTwinChanged
    }
  })], 1)], 1) : _vm._e(), _vm.twinCanBeEdited ? _c('core-button', {
    attrs: {
      "data-cy": "btn_twin_save",
      "title": _vm.$i18n_t('Common.save'),
      "color": _vm.color,
      "disabled": !_vm.valid || _vm.cloading,
      "solid-icon": "",
      "prepend-icon": "fa-save",
      "type": "submit"
    }
  }) : _vm._e(), !_vm.parentIsDisabled ? [_vm.hasTwinManagePermission && _vm.twinCanBeEdited ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable'),
      "data-cy": "btn_twin_disable",
      "color": "danger",
      "prepend-icon": "fa-toggle-off",
      "disabled": _vm.cloading
    },
    on: {
      "click": function ($event) {
        _vm.disableDialog = true;
        _vm.fetchTwinDependencies(_vm.twinObject);
      }
    }
  }) : _vm.hasTwinManagePermission ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinEnable'),
      "data-cy": "btn_twin_enable",
      "color": _vm.color,
      "prepend-icon": "fa-toggle-on",
      "disabled": _vm.cloading
    },
    on: {
      "click": _vm.dtwinToggleState
    }
  }) : _vm._e()] : _vm._e(), _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('Common.cancel'),
      "color": "danger",
      "disabled": _vm.cloading,
      "data-cy": "btn_twin_close_page",
      "prepend-icon": "fa-times"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          path: `/${_vm.baseLink}`,
          query: {
            openTree: _vm.openTree,
            active: _vm.activeId
          }
        });
      }
    }
  })], 2)]), _c(VRow, {
    staticClass: "n20-mainrow pb-4 pt-1",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VCard, {
    staticClass: "mb-8"
  }, [_c(VCardText, [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-dashboard",
      "data-cy": "tab-dashboard"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.drawer.twinDashboard')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-main",
      "data-cy": "tab-main"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinInformation')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-details",
      "data-cy": "tab-details"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinDetails')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-states",
      "data-cy": "tab-states"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataStates')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-rules",
      "data-cy": "tab-rules"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.tabItem')) + "\n              ")]), _c(VTab, {
    attrs: {
      "href": "#tab-rulesoverview",
      "data-cy": "tab-rulesoverview"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.tabItem')) + "\n              ")]), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "dashboard",
    attrs: {
      "value": "tab-dashboard"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.dashboardSelection,
      "item-text": "name",
      "item-value": "id",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.dashboard.select'),
      "loading": _vm.isLoadingDashboards
    },
    model: {
      value: _vm.dashboardId,
      callback: function ($$v) {
        _vm.dashboardId = $$v;
      },
      expression: "dashboardId"
    }
  }), _vm.twinObject.dashboardId ? _c(VCard, {
    style: {
      backgroundColor: _vm.UiTheme ? '#2d2d2d' : '#E5E5E5'
    }
  }, [_c('dashboard', {
    attrs: {
      "dashboardId": _vm.twinObject.dashboardId,
      "widget-min-size": 2
    }
  })], 1) : _c('core-dtwin-state-preview-db-tiles', {
    staticClass: "mt-4",
    attrs: {
      "twinDataStates": _vm.twinDataStates,
      "updatedStates": _vm.updatedStates,
      "loading": _vm.isLoadingStates,
      "noDataAlert": ""
    },
    on: {
      "didUpdateStates": _vm.didUpdateStates
    }
  })], 1), _c(VTabItem, {
    key: "main",
    attrs: {
      "value": "tab-main"
    }
  }, [_c('core-dtwin-edit-information', {
    attrs: {
      "hideFields": ['account'],
      "twinObject": _vm.twinObject,
      "twinTemplate": _vm.twinTemplate,
      "hasTwinManagePermission": _vm.hasTwinManagePermission && _vm.twinCanBeEdited,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "hasUserReadPermission": _vm.permissions['UserManagement.read'],
      "hasVisibleParent": _vm.hasVisibleParent
    },
    on: {
      "scope-updated": function ($event) {
        return _vm.setup();
      }
    }
  })], 1), _c(VTabItem, {
    key: "details",
    attrs: {
      "value": "tab-details"
    }
  }, [_vm.twinObject.id ? _c(VRow, {
    staticClass: "px-2"
  }, [_c('core-dtwin-geo-details', {
    attrs: {
      "twinObject": _vm.twinObject,
      "twinImages": _vm.twinImages,
      "twinCanBeEdited": _vm.twinCanBeEdited,
      "hasFloorTwinReadPermissions": _vm.hasFloorTwinReadPermissions,
      "floorTwinOverlayData": _vm.floorTwinOverlayData
    }
  }), _vm.dtwinTypeValidForIsFm ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('is-fm-fields', {
    attrs: {
      "disabled": !_vm.twinCanBeEdited,
      "propObject": _vm.twinObject.data.isFm
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _c(VTabItem, {
    key: "states",
    attrs: {
      "value": "tab-states"
    }
  }, [_vm.twinObject.tenantId && _vm.twinDataStates ? _c('core-dtwin-state-table', {
    ref: "stateTable",
    attrs: {
      "updatedStates": _vm.updatedStates,
      "disabled": _vm.dtwinIsDisabled,
      "hasTwinManagePermission": _vm.twinCanBeEdited && _vm.hasTwinManagePermission,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "tenantId": _vm.twinObject.tenantId,
      "twinModel": _vm.twinObject,
      "isVirtualDevice": false
    },
    on: {
      "statesUpdated": _vm.refreshStates,
      "refresh": _vm.refreshStates,
      "finishedLoading": _vm.finishedLoadingStatesTable,
      "showExportModal": _vm.showExportModal
    },
    model: {
      value: _vm.twinDataStates,
      callback: function ($$v) {
        _vm.twinDataStates = $$v;
      },
      expression: "twinDataStates"
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: "rules",
    attrs: {
      "value": "tab-rules"
    }
  }, [_vm.twinObject.tenantId ? _c('core-dtwin-rule-table', {
    ref: "rulesTable",
    attrs: {
      "stateTable": _vm.$refs.stateTable,
      "disabled": _vm.dtwinIsDisabled,
      "hasTwinManagePermission": _vm.twinCanBeEdited && _vm.hasTwinManagePermission,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "dtwin": _vm.twinObject
    },
    model: {
      value: _vm.twinDataStates,
      callback: function ($$v) {
        _vm.twinDataStates = $$v;
      },
      expression: "twinDataStates"
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: "rulesoverview",
    attrs: {
      "value": "tab-rulesoverview"
    }
  }, [_vm.twinObject.tenantId ? _c('core-dtwin-rule-overview-table', {
    ref: "rulesOverviewTable",
    attrs: {
      "stateTable": _vm.$refs.stateTable,
      "disabled": _vm.dtwinIsDisabled,
      "hasTwinManagePermission": _vm.twinCanBeEdited && _vm.hasTwinManagePermission,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "dtwinId": _vm.twinObject.id,
      "tenantId": _vm.twinObject.tenantId
    },
    model: {
      value: _vm.twinDataStates,
      callback: function ($$v) {
        _vm.twinDataStates = $$v;
      },
      expression: "twinDataStates"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };